import {
  MslMcpProxyRequestSchema,
  getMslMcpRouteDefinition,
  type JsonValue,
  type MslMcpProxyQuery,
  type MslMcpRouteLabel,
  type MslMcpRouteRequestPayload,
  type MslMcpRouteResponsePayload,
} from '@trinity/custom-page-proxy-routes';

type PostResponse<TData> = {
  data: TData;
};

type AuthenticatedHttpClient = {
  post: <TData>(
    url: string,
    data?: { route: string; payload: JsonValue; query?: Record<string, string> }
  ) => Promise<PostResponse<TData>>;
};

export class MslMcpProxyClient<
  TAuthenticatedClient extends AuthenticatedHttpClient = AuthenticatedHttpClient,
> {
  constructor(private authenticatedClient: TAuthenticatedClient) {}

  async invokeMslMcpRoute<TLabel extends MslMcpRouteLabel>(
    routeLabel: TLabel,
    payload: MslMcpRouteRequestPayload<TLabel>,
    query?: MslMcpProxyQuery
  ): Promise<MslMcpRouteResponsePayload<TLabel>> {
    const route = getMslMcpRouteDefinition(routeLabel);
    route.requestSchema.parse(payload);

    const requestBody = MslMcpProxyRequestSchema.parse({
      route: routeLabel,
      payload,
      query,
    });

    const response = await this.authenticatedClient.post<JsonValue>('/proxy/custom-pages/msl-mcp', requestBody);

    return route.responseSchema.parse(response.data);
  }
}
